import type { ButtonProps } from "antd";

import { useGetNotificationsDatabaseUnreadCount } from "@/entities/notifications-database";

import { NotificationsMarkAllButton } from "./notifications-mark-all-button.component";

export const NotificationsMarkAllButtonWrapper = (props: ButtonProps) => {
  const { unreadCount } = useGetNotificationsDatabaseUnreadCount();

  if (!unreadCount) return;

  return <NotificationsMarkAllButton {...props} />;
};
